import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PerformanceRatingScaleOption } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import { AnswerRating } from 'modules/questionnaires/components/Answer/AnswerRating'
import { RatingQuestion } from 'modules/questionnaires/lib/types'

type Props = {
  scoreScale: PerformanceRatingScaleOption[]
  sectionHeaderAddon?: React.ReactNode | undefined
  isJobCatalogTreeEnabled: boolean
}

// TODO: refactor this to use questionnaire response after adding the alerts to it
export const CompetenciesAssessmentsResponsesPlaceholder: React.FC<Props> = ({
  scoreScale,
  sectionHeaderAddon,
  isJobCatalogTreeEnabled,
}) => {
  const questionPlaceholder: RatingQuestion = {
    uuid: 'competencies-assessments-response-1',
    answerType: 'rating',
    withComment: true,
    mandatory: true,
    title: isJobCatalogTreeEnabled
      ? i18n.t(
          'performance_process.reviews.competencies_assessment_response_placeholder.compentency_name_with_levels'
        )
      : i18n.t(
          'performance_process.reviews.competencies_assessment_response_placeholder.compentency_name'
        ),
    description: i18n.t(
      'performance_process.reviews.competencies_assessment_response_placeholder.compentency_description'
    ),
    scale: scoreScale.map((scale) => ({
      text: scale.text,
      value: scale.value,
    })),
    choiceOptions: [],
  }

  const questions = [
    questionPlaceholder,
    {
      ...questionPlaceholder,
      uuid: 'competencies-assessments-response-2',
    },
  ]

  return (
    <Box
      width="full"
      background="grey100"
      padding="s24"
      gap="s24"
      borderRadius={{ all: 'abs016' }}
      aria-labelledby="section-title-competencies-assessments-response-placeholder"
    >
      <Box
        flexDirection="row"
        alignItems="center"
        gap="s8"
        justifyContent="spaceBetween"
        style={{ flexGrow: '1' }}
      >
        <Text weight="semibold" size="400" color="black">
          {i18n.t('performance_process.reviews.competencies_assessment_response_placeholder.title')}
        </Text>
        {sectionHeaderAddon}
      </Box>

      <Callout
        type="info"
        description={
          isJobCatalogTreeEnabled
            ? i18n.t(
                'performance_process.reviews.competencies_assessment_response_placeholder.callout.description_with_competency_levels'
              )
            : i18n.t(
                'performance_process.reviews.competencies_assessment_response_placeholder.callout.description'
              )
        }
        hideIcon={false}
      />
      <>
        {questions.map((q, index) => (
          <AnswerRating key={q.uuid} question={q} onChange={() => ({})} position={index + 1} />
        ))}
      </>
    </Box>
  )
}
